import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, isRef as _isRef, vModelText as _vModelText, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0fb32c92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 row" }
const _hoisted_3 = { class: "col-12 col-md-4" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = ["value", "onBlur", "onFocus"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invalid-feedback" }, " Укажите дату тендера ", -1))
const _hoisted_7 = { class: "col-12 col-md-4" }
const _hoisted_8 = { class: "col-12 col-md-4" }
const _hoisted_9 = { class: "flex items-center" }
const _hoisted_10 = ["value", "onBlur", "onFocus"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invalid-feedback" }, " Укажите дату заезда ", -1))
const _hoisted_12 = { class: "col-12 row" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 h6" }, [
  /*#__PURE__*/_createElementVNode("hr"),
  /*#__PURE__*/_createTextVNode(" Проект (лот) ")
], -1))
const _hoisted_14 = { class: "col-12 col-md-3" }
const _hoisted_15 = { class: "col-12 col-md-3" }
const _hoisted_16 = { class: "col-12 col-md-3" }
const _hoisted_17 = { class: "col-12 col-md-3" }
const _hoisted_18 = { class: "col-12 col-md-8 row" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 h6" }, [
  /*#__PURE__*/_createElementVNode("hr"),
  /*#__PURE__*/_createTextVNode(" Стоимость ")
], -1))
const _hoisted_20 = { class: "col-12 col-md-8" }
const _hoisted_21 = { class: "col-12 col-md-4 d-flex align-items-center" }
const _hoisted_22 = { class: "form-check form-check-inline" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-check-label" }, "НДС", -1))
const _hoisted_24 = { class: "col-12 col-md-4 row" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 h6" }, [
  /*#__PURE__*/_createElementVNode("hr"),
  /*#__PURE__*/_createTextVNode(" Условия участия ")
], -1))
const _hoisted_26 = { class: "col-12" }
const _hoisted_27 = { class: "col-12" }
const _hoisted_28 = { class: "col-12" }
const _hoisted_29 = { class: "col-12 row" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 h6" }, [
  /*#__PURE__*/_createElementVNode("hr"),
  /*#__PURE__*/_createTextVNode(" Условия контракта ")
], -1))
const _hoisted_31 = { class: "col-12 col-md-4" }
const _hoisted_32 = { class: "col-12 col-md-4" }
const _hoisted_33 = { class: "col-12 col-md-4" }
const _hoisted_34 = { class: "col-12 col-md-6" }
const _hoisted_35 = { class: "col-12 col-md-6" }
const _hoisted_36 = { class: "col-12 col-md-4 d-flex align-items-center" }
const _hoisted_37 = { class: "form-check form-check-inline" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-check-label" }, "Оплата сверхцикла", -1))
const _hoisted_39 = { class: "col-12 col-md-4 d-flex align-items-center" }
const _hoisted_40 = { class: "form-check form-check-inline" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-check-label" }, "Установка доп. оборудование", -1))
const _hoisted_42 = { class: "col-12 col-md-4 d-flex align-items-center" }
const _hoisted_43 = { class: "form-check form-check-inline" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-check-label" }, "Спец.условия", -1))
const _hoisted_45 = { class: "col-12" }
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "col-12 text-center" }

import { onMounted, reactive, computed, ref } from "vue";
import { DatePicker } from 'v-calendar';
import { useTextareaAutosize } from '@vueuse/core';
import { PORTAL_COLLECTION } from '@depo/constants/project-register';
import { useModal } from "@/composables/useModal";
import api from "@/api";
import { ILocomotive } from "@/@types/ILocomotive";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectRegisterModal',
  props: {
    id: {
        type: String,
        default: '',
    },
},
  setup(__props) {

const props = __props;

const modal = useModal(props.id);

const state = reactive({
    title: '',
    tenderStartsAt: new Date(),
    contractorId: '',
    locomotiveModelId: '',
    locomotiveId: '',
    jobCategoryId: '',
    totalWithoutVAT: '',
    isVATIncluded: false,
    isOvercyclePaid: false,
    isAdditionalEquipmentInstalled: false,
    isSpecialConditions: false,
    oidPercent: '',
    advancePercent: '',
    repairPeriodDays: '',
    daysToGetPaidAfterActOfWorkPerformedSubmit: '',
    fullPayment: '',
    demuragePenalty: '',
    tenderSecurityPercent: '',
    portal: '',
    entersAt: '',
    comment: '',
    visibleErrors: false,
    loader: false,
});

const contractors = ref([]);
const jobCategories = ref([]);
const locoModels = ref([]);
const locomotives = ref<Array<ILocomotive>>([]);
const { input: qualificationRequirements, textarea: qualificationRequirementRef } = useTextareaAutosize();

const isTenderStartsAtError = computed(() => !state.tenderStartsAt);
const isEntersAtError = computed(() => !state.entersAt);
const isContractorIdError = computed(() => !state.contractorId);
const isLocoModelIdError = computed(() => !state.locomotiveModelId);
const isJobCategoryIdError = computed(() => !state.jobCategoryId);
const isTotalError = computed(() => !state.totalWithoutVAT.length ? false : /^[0-9]{12}$/.test(state.totalWithoutVAT));
const isOidError = computed(() => !state.oidPercent.length ? false : (+state.oidPercent > 100 || +state.oidPercent < 0));
const isTenderSecurityError = computed(() => !state.tenderSecurityPercent.length ? false : (+state.tenderSecurityPercent > 100 || +state.tenderSecurityPercent < 0));
const isAdvanceError = computed(() => !state.advancePercent.length ? false : (+state.advancePercent > 100 || +state.advancePercent < 0));
const isDemuragePenaltyError = computed(() => !state.demuragePenalty.length ? false : (+state.demuragePenalty > 100 || +state.demuragePenalty < 0));
const isRepairPeriodError = computed(() => !state.repairPeriodDays.length ? false : /^[0-9]{12}$/.test(state.repairPeriodDays));
const isDaysToGetPaidAfterActOfWorkPerformedSubmitError = computed(() => !state.daysToGetPaidAfterActOfWorkPerformedSubmit.length ? false : /^[0-9]{12}$/.test(state.daysToGetPaidAfterActOfWorkPerformedSubmit));
const isPortalError = computed(() => !state.portal.length);

const filteredLocomotives = computed(() => {
    if (isLocoModelIdError.value || isContractorIdError.value) {
        return [];
    }

    return locomotives.value.filter(locomotive => locomotive.contractorId === Number(state.contractorId) && locomotive.modelId === Number(state.locomotiveModelId));
});

function onDemuragePenaltyEnter() {
    state.demuragePenalty = state.demuragePenalty.replaceAll(',', '.');
}

function onContractorSelected(contractor: any) {
    state.contractorId = contractor.id;
    state.locomotiveId = '';
}

function onLocoModelSelected(locomotive: any) {
    state.locomotiveModelId = locomotive.id;
    state.locomotiveId = '';
}

function onLocomotiveSelected(locomotive: any) {
    state.locomotiveId = locomotive.id;
}

function onJobCategorySelected(category: any) {
    state.jobCategoryId = category.id;
}

function handleCategoryTypesSelect(_c: any) {
    state.portal = _c.id;
}

const errors = computed(() => {
    return isTenderStartsAtError.value ||
        isContractorIdError.value ||
        isLocoModelIdError.value ||
        isJobCategoryIdError.value ||
        isTotalError.value ||
        isOidError.value ||
        isTenderSecurityError.value ||
        isAdvanceError.value ||
        isRepairPeriodError.value ||
        isDaysToGetPaidAfterActOfWorkPerformedSubmitError.value ||
        isPortalError.value ||
        isEntersAtError.value;
});

onMounted(() => {
    if (modal.data.type === 'add') {
        state.title = 'Создание реестра проектов';
    } else {
        state.title = 'Редактирование реестра проектов';
        state.tenderStartsAt = modal.data.projectRegister.tenderStartsAt;
        state.contractorId = modal.data.projectRegister.contractorId;
        state.locomotiveModelId = modal.data.projectRegister.locomotiveModelId;
        state.locomotiveId = modal.data.projectRegister.locomotiveId;
        state.jobCategoryId = modal.data.projectRegister.jobCategoryId;
        state.totalWithoutVAT = modal.data.projectRegister.totalWithoutVAT;
        state.oidPercent = modal.data.projectRegister.oidPercent;
        state.advancePercent = modal.data.projectRegister.advancePercent;
        state.repairPeriodDays = modal.data.projectRegister.repairPeriodDays;
        state.daysToGetPaidAfterActOfWorkPerformedSubmit = modal.data.projectRegister.daysToGetPaidAfterActOfWorkPerformedSubmit;
        state.comment = modal.data.projectRegister.comment;
        state.isVATIncluded = modal.data.projectRegister.isVATIncluded;
        state.fullPayment = modal.data.projectRegister.fullPayment;
        state.demuragePenalty = modal.data.projectRegister.demuragePenalty;
        state.portal  = modal.data.projectRegister.portal;
        state.entersAt = modal.data.projectRegister.entersAt;
        state.isAdditionalEquipmentInstalled = modal.data.projectRegister.isAdditionalEquipmentInstalled;
        state.isOvercyclePaid = modal.data.projectRegister.isOvercyclePaid;
        state.isSpecialConditions = modal.data.projectRegister.isSpecialConditions;
        state.tenderSecurityPercent = modal.data.projectRegister.tenderSecurityPercent;
        qualificationRequirements.value = modal.data.projectRegister.qualificationRequirements;
    }

    api.info.get().then((r: any) => {
        contractors.value = r.data.contractors;
        jobCategories.value = r.data.jobCategories;
        locoModels.value = r.data.locoModels;
    });
    api.locomotives.getAll().then(data => {
        locomotives.value = data;
    }).catch(console.error);
});

function send() {
    if (errors.value) {
        state.visibleErrors = true;
        return;
    }
    state.visibleErrors = false;
    state.loader = true;

    const dataToUpdateOrCreate = {
        tenderStartsAt: state.tenderStartsAt,
        contractorId: state.contractorId,
        locomotiveModelId: state.locomotiveModelId,
        locomotiveId: state.locomotiveId || null,
        jobCategoryId: state.jobCategoryId,
        totalWithoutVAT: state.totalWithoutVAT,
        oidPercent: state.oidPercent,
        advancePercent: state.advancePercent,
        repairPeriodDays: state.repairPeriodDays,
        daysToGetPaidAfterActOfWorkPerformedSubmit: state.daysToGetPaidAfterActOfWorkPerformedSubmit,
        comment: state.comment,
        isVATIncluded: state.isVATIncluded,
        fullPayment: state.fullPayment,
        demuragePenalty: state.demuragePenalty,
        entersAt: state.entersAt,
        qualificationRequirements: qualificationRequirements.value,
        portal: state.portal,
        isAdditionalEquipmentInstalled: state.isAdditionalEquipmentInstalled,
        isOvercyclePaid: state.isOvercyclePaid,
        isSpecialConditions: state.isSpecialConditions,
        tenderSecurityPercent: state.tenderSecurityPercent,
    };

    if (modal.data.type === 'add') {
        api.projectRegister.create(dataToUpdateOrCreate).then(() => {
            modal.ok({ isSuccess: true });
        }).finally(() => state.loader = false);
        return;
    }

    api.projectRegister.update(modal.data.projectRegister.id, dataToUpdateOrCreate).then(() => {
        modal.ok({ isSuccess: true });
    }).finally(() => state.loader = false);
}

return (_ctx: any,_cache: any) => {
  const _component_loader_ui = _resolveComponent("loader-ui")!
  const _component_form_group_ui = _resolveComponent("form-group-ui")!
  const _component_select_ui = _resolveComponent("select-ui")!
  const _component_input_ui = _resolveComponent("input-ui")!
  const _component_button_ui = _resolveComponent("button-ui")!
  const _component_modal_ui = _resolveComponent("modal-ui")!

  return (_openBlock(), _createBlock(_component_modal_ui, {
    id: __props.id,
    size: "modal-lg",
    title: state.title
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: "loader",
        onSubmit: _withModifiers(send, ["prevent"])
      }, [
        _createVNode(_component_loader_ui, {
          "is-show": state.loader
        }, null, 8, ["is-show"]),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_form_group_ui, {
                "invalid-feedback": "Выберите дату тендера",
                label: "Дата тендера",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DatePicker), {
                    modelValue: state.tenderStartsAt,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.tenderStartsAt) = $event)),
                    class: "inline-block h-full",
                    is24hr: true,
                    mode: "date"
                  }, {
                    default: _withCtx(({ inputValue, togglePopover }) => [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("input", {
                          class: _normalizeClass(["form-control", { 'is-invalid': isTenderStartsAtError.value && state.visibleErrors, 'bg-white': true }]),
                          as: "",
                          readonly: "",
                          timezone: 'Asia/Almaty',
                          value: inputValue,
                          onBlur: ($event: any) => (togglePopover()),
                          onFocus: ($event: any) => (togglePopover())
                        }, null, 42, _hoisted_5),
                        _hoisted_6
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_form_group_ui, {
                "invalid-feedback": "Укажите портал",
                label: "Портал"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_select_ui, {
                    "is-invalid": state.visibleErrors && isPortalError.value,
                    options: _unref(PORTAL_COLLECTION).map(c => ({ name: c.URL, id: c.URL })),
                    placeholder: "Портал",
                    values: [state.portal],
                    onOnUpdated: handleCategoryTypesSelect
                  }, null, 8, ["is-invalid", "options", "values"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_form_group_ui, {
                "invalid-feedback": "Выберите дату заезда",
                label: "Дата заезда",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DatePicker), {
                    modelValue: state.entersAt,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.entersAt) = $event)),
                    class: "inline-block h-full",
                    is24hr: true,
                    mode: "date"
                  }, {
                    default: _withCtx(({ inputValue, togglePopover }) => [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("input", {
                          class: _normalizeClass(["form-control", { 'is-invalid': isEntersAtError.value && state.visibleErrors, 'bg-white': true }]),
                          as: "",
                          readonly: "",
                          timezone: 'Asia/Almaty',
                          value: inputValue,
                          onBlur: ($event: any) => (togglePopover()),
                          onFocus: ($event: any) => (togglePopover())
                        }, null, 42, _hoisted_10),
                        _hoisted_11
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_form_group_ui, {
                "invalid-feedback": "Выберите клиента",
                label: "Клиент",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_select_ui, {
                    "is-invalid": state.visibleErrors && isContractorIdError.value,
                    "item-key": "name",
                    options: contractors.value,
                    placeholder: "Клиент",
                    searchable: true,
                    values: [state.contractorId],
                    onOnSelected: onContractorSelected
                  }, null, 8, ["is-invalid", "options", "values"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_form_group_ui, {
                "invalid-feedback": "Выберите ПС",
                label: "ПС",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_select_ui, {
                    "is-invalid": state.visibleErrors && isLocoModelIdError.value,
                    "item-key": "model",
                    options: locoModels.value,
                    placeholder: "ПС",
                    searchable: true,
                    values: [state.locomotiveModelId],
                    onOnSelected: onLocoModelSelected
                  }, null, 8, ["is-invalid", "options", "values"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_form_group_ui, { label: "Гос.номер" }, {
                default: _withCtx(() => [
                  _createVNode(_component_select_ui, {
                    "item-key": "name",
                    options: filteredLocomotives.value,
                    placeholder: "Гос.номер",
                    searchable: true,
                    values: [state.locomotiveId],
                    onOnSelected: onLocomotiveSelected
                  }, null, 8, ["options", "values"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_form_group_ui, {
                "invalid-feedback": "Выберите вид работ",
                label: "Вид работ",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_select_ui, {
                    "is-invalid": state.visibleErrors && isJobCategoryIdError.value,
                    "item-key": "name",
                    options: jobCategories.value,
                    placeholder: "Вид работ",
                    searchable: true,
                    values: [state.jobCategoryId],
                    onOnSelected: onJobCategorySelected
                  }, null, 8, ["is-invalid", "options", "values"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_form_group_ui, {
                "invalid-feedback": "Введите стоимость",
                label: "Стоимость без НДС (тенге)"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_input_ui, {
                    modelValue: state.totalWithoutVAT,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((state.totalWithoutVAT) = $event)),
                    mask: { mask: 'Z*', tokens: { 'Z': { pattern: /^[0-9.,]+$/ } } },
                    maxlength: "12",
                    "is-invalid": state.visibleErrors && isTotalError.value,
                    placeholder: ""
                  }, null, 8, ["modelValue", "is-invalid"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("label", _hoisted_22, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((state.isVATIncluded) = $event)),
                  class: "form-check-input",
                  type: "checkbox"
                }, null, 512), [
                  [_vModelCheckbox, state.isVATIncluded]
                ]),
                _hoisted_23
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_component_form_group_ui, {
                "invalid-feedback": "Введите ОИД",
                label: "ОИД (%)"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_input_ui, {
                    modelValue: state.oidPercent,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((state.oidPercent) = $event)),
                    mask: { mask: 'Z*', tokens: { 'Z': { pattern: /^[0-9.,]+$/ } } },
                    maxlength: "3",
                    "is-invalid": state.visibleErrors && isOidError.value,
                    placeholder: ""
                  }, null, 8, ["modelValue", "is-invalid"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_component_form_group_ui, {
                "invalid-feedback": "Введите Тендерное обеспечение",
                label: "Тендерное обеспечение (%)"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_input_ui, {
                    modelValue: state.tenderSecurityPercent,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((state.tenderSecurityPercent) = $event)),
                    mask: { mask: 'Z*', tokens: { 'Z': { pattern: /^[0-9.,]+$/ } } },
                    maxlength: "3",
                    "is-invalid": state.visibleErrors && isTenderSecurityError.value,
                    placeholder: ""
                  }, null, 8, ["modelValue", "is-invalid"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createVNode(_component_form_group_ui, { label: "Квалификационные требования" }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(qualificationRequirements) ? (qualificationRequirements).value = $event : null)),
                  ref_key: "qualificationRequirementRef",
                  ref: qualificationRequirementRef
                }, null, 512), [
                  [_vModelText, _unref(qualificationRequirements)]
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_form_group_ui, {
                "invalid-feedback": "Введите аванс",
                label: "Аванс (%)"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_input_ui, {
                    modelValue: state.advancePercent,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((state.advancePercent) = $event)),
                    mask: { mask: 'Z*', tokens: { 'Z': { pattern: /^[0-9.,]+$/ } } },
                    maxlength: "3",
                    "is-invalid": state.visibleErrors && isAdvanceError.value,
                    placeholder: ""
                  }, null, 8, ["modelValue", "is-invalid"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createVNode(_component_form_group_ui, {
                "invalid-feedback": "Введите дни",
                label: "Оплата после сдачи АВР (дни)"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_input_ui, {
                    modelValue: state.daysToGetPaidAfterActOfWorkPerformedSubmit,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((state.daysToGetPaidAfterActOfWorkPerformedSubmit) = $event)),
                    mask: { mask: 'Z*', tokens: { 'Z': { pattern: /^[0-9.,]+$/ } } },
                    maxlength: "12",
                    "is-invalid": state.visibleErrors && isDaysToGetPaidAfterActOfWorkPerformedSubmitError.value,
                    placeholder: ""
                  }, null, 8, ["modelValue", "is-invalid"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createVNode(_component_form_group_ui, {
                "invalid-feedback": "Введите срок ремонта",
                label: "Срок ремонта (дни)"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_input_ui, {
                    modelValue: state.repairPeriodDays,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((state.repairPeriodDays) = $event)),
                    mask: { mask: 'Z*', tokens: { 'Z': { pattern: /^[0-9.,]+$/ } } },
                    maxlength: "12",
                    "is-invalid": state.visibleErrors && isRepairPeriodError.value,
                    placeholder: ""
                  }, null, 8, ["modelValue", "is-invalid"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createVNode(_component_form_group_ui, { label: "Полная оплата" }, {
                default: _withCtx(() => [
                  _createVNode(_component_input_ui, {
                    modelValue: state.fullPayment,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((state.fullPayment) = $event)),
                    placeholder: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createVNode(_component_form_group_ui, {
                "invalid-feedback": "Введите проценты",
                label: "Пеня за простой (%)"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_input_ui, {
                    modelValue: state.demuragePenalty,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((state.demuragePenalty) = $event)),
                    modelModifiers: { lazy: true },
                    mask: { mask: 'Z*', tokens: { 'Z': { pattern: /^[0-9.,]+$/ } } },
                    maxlength: "12",
                    onInput: onDemuragePenaltyEnter,
                    "is-invalid": state.visibleErrors && isDemuragePenaltyError.value,
                    placeholder: ""
                  }, null, 8, ["modelValue", "is-invalid"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("label", _hoisted_37, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((state.isOvercyclePaid) = $event)),
                  class: "form-check-input",
                  type: "checkbox"
                }, null, 512), [
                  [_vModelCheckbox, state.isOvercyclePaid]
                ]),
                _hoisted_38
              ])
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("label", _hoisted_40, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((state.isAdditionalEquipmentInstalled) = $event)),
                  class: "form-check-input",
                  type: "checkbox"
                }, null, 512), [
                  [_vModelCheckbox, state.isAdditionalEquipmentInstalled]
                ]),
                _hoisted_41
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("label", _hoisted_43, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((state.isSpecialConditions) = $event)),
                  class: "form-check-input",
                  type: "checkbox"
                }, null, 512), [
                  [_vModelCheckbox, state.isSpecialConditions]
                ]),
                _hoisted_44
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Укажите примечание",
              label: "Примечание"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_input_ui, {
                  modelValue: state.comment,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((state.comment) = $event)),
                  placeholder: "Примечание"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            _createVNode(_component_button_ui, { "button-class": "btn-primary" }, {
              default: _withCtx(() => [
                _createTextVNode(" Сохранить ")
              ]),
              _: 1
            })
          ])
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["id", "title"]))
}
}

})